import React from 'react';

export const NoItemsYet = ({ image, title, description, classNameWrapper, stylesWrapper, stylesBox }) => {
  return (
    <div
      className={`no-items-yet-wrapper ${classNameWrapper ? classNameWrapper : ''}`}
      style={stylesWrapper ? stylesWrapper : {}}
    >
      <div
        className='no-items-yet-box'
        style={stylesBox ? stylesBox : {}}
      >
        {image &&
          <div className='no-items-yet-img'>
            <img src={image} alt='empty-img' />
          </div>
        }
        {title &&
          <h4 className='no-items-yet-title'>
            {title}
          </h4>
        }

        {description &&
          <p className='no-items-yet-description'>
            {description}
          </p>
        }
      </div>
    </div>
  );
};

